// extracted by mini-css-extract-plugin
module.exports = {"dealing":"UserServices_dealing__1HeQY","types":"UserServices_types__2sJ9L","title":"UserServices_title__kfB9R","disabledTab":"UserServices_disabledTab__1HzsL"};